<template>
  <div>
    <div class="sharemag_top_bar">
      <span class="sharemag_tip sharemag_tip_noac" @click="goTome"
        >个人中心</span
      >
      <i class="el-icon-arrow-right"></i>
      <span class="sharemag_tip">分享管理</span>
    </div>

    <div class="sharemag_bgcon">
      <div class="sharemag_tp_con">
        <div
          v-for="(tp, index) in tpList"
          :class="
            index == curSes
              ? 'sharemag_tp_item sharemag_tp_item_active'
              : 'sharemag_tp_item'
          "
          @click="tpses(index)"
        >
          {{ tp }}
        </div>
      </div>
      <div>
        <div class="sharemag_artitem_top">
          <div class="sharemag_artitem_top_name">文章标题</div>
          <div class="sharemag_artitem_top_name">好友/团队</div>
          <div class="sharemag_artitem_top_name">分享时间</div>
        </div>
        <div class="sharemag_artitem" v-for="item in shareList">
          <!-- 根据当前tp内容显示不同字段 -->
          <template v-if="tpList[curSes] === '我分享的'">
            <div class="sharemag_artitem_name" @click="detail(item.articleId)">
              {{ item.articleTitle }}
            </div>
            <div class="sharemag_artitem_name" v-if="item.friendName">
              {{ item.remark || item.friendName }}
            </div>
            <div class="sharemag_artitem_name" v-else>
              {{ item.groupName }}
            </div>
          </template>
          <template v-else-if="tpList[curSes] === '我收到的'">
            <div
              class="sharemag_artitem_name"
              @click="ReceiveArticleDetail(item.articleId, item.sendUid)"
            >
              {{ item.articleTitle }}
            </div>
            <div class="sharemag_artitem_name" v-if="item.groupName">
              {{ item.groupName }}
            </div>
            <div class="sharemag_artitem_name" v-else>
              {{ item.sendName }}
            </div>
          </template>
          <div class="sharemag_artitem_name">{{ format(item.createTime) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  insertShareHistroy,
  selectSend,
  selectReceive,
  selectReceiveGroup,
} from "@/api/shareHistory";
import { receiveArticleInfo } from "@/api/article";
import dayjs from "dayjs";

export default {
  name: "artdetail",
  data() {
    return {
      stimeval: "",
      ctimeval: "",
      tpList: ["我分享的", "我收到的"],
      curSes: 0,
      shareList: [],
    };
  },
  mounted() {
    selectSend()
      .then((response) => {
        // 更新 shareList 为 API 响应数据
        this.shareList = response.data;
      })
      .catch((error) => {
        // 处理错误情况
        console.error("Error fetching shared articles: ", error);
      });
  },
  methods: {
    goTome() {
      this.$router.push({ name: "me" });
    },
    tpses(index) {
      this.curSes = index;

      // 判断当前选中的是哪一个选项
      if (this.tpList[index] === "我分享的") {
        selectSend()
          .then((response) => {
            console.log(response);
            // 更新 shareList 为 API 响应数据
            this.shareList = response.data;
          })
          .catch((error) => {
            // 处理错误情况
            console.error("Error fetching shared articles: ", error);
          });
      } else if (this.tpList[index] === "我收到的") {
        //现在是通过receiveid获取的接受历史，所以数据库的群聊历史没有接收到
        selectReceive()
          .then((response) => {
            this.shareList = response.data; // 更新个人接收列表
            // 获取群组接收列表
            return selectReceiveGroup();
          })
          .then((groupResponse) => {
            // 合并个人和群组接收列表
            this.shareList = this.shareList.concat(groupResponse.data);
            this.shareList = this.shareList
              .map((item) => {
                return {
                  ...item,
                  createTime: new Date(item.createTime),
                };
              })
              .sort((a, b) => {
                return b.createTime - a.createTime;
              });
          })
          .catch((error) => {
            // 处理错误情况
            console.error("Error fetching received articles: ", error);
          });
      }
    },
    detail(articleId) {
      if (articleId == null || articleId == "") {
        return;
      }
      this.$router.push({
        name: "artdetail",
        query: {
          aid: articleId,
        },
      });
    },
    ReceiveArticleDetail(articleId, sendUid) {
      if (articleId == null || articleId == "") {
        return;
      }
      console.log("ReceiveArticleDetail", articleId, sendUid);
      this.$router.push({
        name: "artdetail",
        query: {
          aid: articleId,
          isReceiveShareDetail: true,
          sendUid: sendUid,
        },
      });
    },
    share() {
      var that = this;

      that.$router.push({ name: "artshare", params: { refresh: true } });
    },
    format(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>

<style>
.sharemag_artitem_name {
  color: #262626;
  font-size: 16px;
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.sharemag_artitem_top_name {
  color: #262626;
  font-size: 18px;
  font-weight: 550;
  flex: 1;
  text-align: center;
}

.sharemag_artitem_top {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: solid 1px #cccccc;
}

.sharemag_artitem {
  padding: 12px;
  border-bottom: solid 1px #cccccc;
  display: flex;
  align-items: center;
}

.sharemag_tp_item_active {
  color: #2683be !important;
  border-bottom: solid 1px #2683be;
}

.sharemag_tp_item {
  color: #262626;
  font-size: 18px;
  font-weight: 550;
  margin-right: 20px;
  cursor: pointer;
  padding-bottom: 4px;
}

.sharemag_tp_con {
  display: flex;
  align-items: center;
  background-color: #dedede;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: solid 1px #cccccc;
}

.sharemag_bgcon {
  margin-top: 30px;
  border: solid 1px #dedede;
}

.sharemag_start_col_btn {
  background-image: url("../assets/btnbg.png");
  width: 99px;
  height: 30px;
  background-position: left;
  background-repeat: no-repeat;
  background-size: cover;
  margin-left: 220px;
  color: white;
  border: none;
  cursor: pointer;
}

.sharemag_add_in_con1 {
  width: 220px;
}

.sharemag_el-dropdown-link {
  border: solid 2px #0187ea;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 200px;
  font-size: 18px;
}

.argmag_add_in {
  margin-left: 5px;
  background: none;
  font-size: 18px;
  border: none;
  outline: none;
}

.argmag_add_in::placeholder {
  font-size: 18px;
  color: #999999;
}

.argmag_add_in:focus {
  outline: none;
}

.sharemag_add_in_con {
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border: solid 2px #0187ea;
  background-color: #edf7f9;
  width: 220px;
}

.sharemag_txt_label {
  color: #333333;
  font-size: 18px;
  font-weight: 550;
}

.sharemag_line_con {
  display: flex;
  align-items: center;
}

.sharemag_tip_noac {
  color: #707070 !important;
}

.sharemag_tip {
  font-size: 18px;
  color: #2683be;
  cursor: pointer;
}

.sharemag_top_bar {
  display: flex;
  align-items: center;
}
</style>
